import { cva } from 'class-variance-authority';
import { Loader2Icon } from 'lucide-react';

import { cn } from '../../utils/cn.js';

const spinnerVariants = cva('flex-col items-center justify-center', {
  variants: {
    show: {
      true: 'flex',
      false: 'hidden',
    },
  },
  defaultVariants: {
    show: true,
  },
});

const loaderVariants = cva('animate-spin text-primary', {
  variants: {
    size: {
      xxs: 'size-6',
      xs: 'size-8',
      sm: 'size-12',
      md: 'size-20',
      lg: 'size-28',
      xl: 'size-40',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
/**
 * Renders a Spinner component with a customizable size.
 *
 * @param {Object} props - The props for the Loader component.
 * @param {string} [props.size] - The loader size.
 * @param {string} [props.className] - The className.
 *
 * @return {JSX.Element} The Loader component
 */
const Spinner = ({ size, show = true, className }) => {
  return (
    <span className={spinnerVariants({ show })}>
      <Loader2Icon className={cn(loaderVariants({ size }), className)} />
    </span>
  );
};

export default Spinner;
